'use client';

import { useEffect, useState } from 'react';
import { getFortuneReleaseCookie } from '@/app_lib/utils/fortuneReleaseCookie';

export const FortuneReleaseBadge = () => {
  const [value, setValue] = useState<string | null>(null);

  useEffect(() => {
    setValue(getFortuneReleaseCookie());
  }, []);

  if (!value) {
    return null;
  }

  // Ignore project convetions for Tailwind. Needs to work in Pages router without Tailwind.
  return <div style={{ fontSize: 'small', fontWeight: 'normal', lineHeight: '50%' }}>{value}</div>;
};
